import { Button, Dialog } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Widget } from '~/components/MyWorkspace/Widget';

import { WidgetProps } from '../../data/widgets';

import { Content } from './components/Content';
import { MyCompensationDialogContent } from './components/MyCompensationDialogContent';
import { useMyCompensationWidget } from './useMyCompensationWidget';
import { useSxStyles } from './useStyles';

export interface Props extends WidgetProps {}

export const MyCompensationWidget: React.FC<Props> = ({ title }) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  const {
    loading,
    failedToLoad,
    myCompensationSummary,
    isMyCompensationDialogOpen,
    openMyCompensationDialog,
    closeMyCompensationDialog,
    getSalaryFrequency,
  } = useMyCompensationWidget();

  return (
    <>
      <Widget
        title={title || t('myCompensation')}
        content={
          <Content
            loading={loading}
            compensationSummary={myCompensationSummary}
            failedToLoad={failedToLoad}
            getSalaryFrequency={getSalaryFrequency}
          />
        }
        customSxStyles={{ content: sxStyles.root }}
        actions={
          <Button
            size="small"
            color="primary"
            disabled={
              loading || failedToLoad || !myCompensationSummary?.current
            }
            onClick={openMyCompensationDialog}
            sx={sxStyles.actionButton}
          >
            {t('showMore')}
          </Button>
        }
        dataCy="my-compensation-widget"
      />

      <Dialog
        open={isMyCompensationDialogOpen}
        onClose={closeMyCompensationDialog}
        fullWidth={true}
      >
        <>
          {myCompensationSummary && (
            <MyCompensationDialogContent
              compensationSummary={myCompensationSummary}
              getSalaryFrequency={getSalaryFrequency}
            />
          )}
        </>
      </Dialog>
    </>
  );
};
